import { create } from "zustand";
import { persist } from "zustand/middleware";

// Shopping bag for the eCommerce storefront. Persisted to localStorage.
export const useBag = create(
  persist(
    (set, get) => ({
      items: [],
      isOpen: false,

      openBag: () => set({ isOpen: true }),
      closeBag: () => set({ isOpen: false }),

      addItem: (item) => {
        const key = item.variant_id || item.product_id;
        const items = [...get().items];
        const idx = items.findIndex((i) => i.key === key);
        if (idx >= 0) {
          const next = Math.min(items[idx].quantity + (item.quantity || 1), item.max_stock || 99);
          items[idx] = { ...items[idx], quantity: next };
        } else {
          items.push({
            key,
            product_id: item.product_id,
            name: item.name,
            image_url: item.image_url,
            price: item.price,
            variant_id: item.variant_id || null,
            variant_label: item.variant_label || "",
            sku: item.sku || "",
            quantity: item.quantity || 1,
            max_stock: item.max_stock || 99,
          });
        }
        set({ items, isOpen: true });
      },

      setQty: (key, quantity) => {
        if (quantity <= 0) {
          set({ items: get().items.filter((i) => i.key !== key) });
          return;
        }
        set({
          items: get().items.map((i) =>
            i.key === key ? { ...i, quantity: Math.min(quantity, i.max_stock || 99) } : i
          ),
        });
      },

      removeItem: (key) => set({ items: get().items.filter((i) => i.key !== key) }),
      clear: () => set({ items: [] }),

      count: () => get().items.reduce((s, i) => s + i.quantity, 0),
      subtotal: () => get().items.reduce((s, i) => s + i.price * i.quantity, 0),
    }),
    { name: "urban-threads-bag" }
  )
);
